<template>
  <div>

    <!-- 標題 bar -->
    <div class="content-8__titlebar">
      <div class="content-8__titlebar__left">
        <div class="c8-titlename">
          <span class="c8-titlename__text">特码走势</span>
        </div>
      </div>
    </div>

    <div v-loading="isLoading" class="TeMaZouShi">
      <v-chart ref="polar" :options="line" />
    </div>

  </div>
</template>

<script>
import { getTrand } from '@/api/desktop/trend'
export default {
  name: 'TeMaZouShi',
  data() {
    return {
      isLoading: false,
      data: {},
      line: {
        backgroundColor: '#fff',
        color: ['#37A2DA'],
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          show: false,
          x: 'left',
          selected: {
            '特码': true
          }
        },
        xAxis: {
          type: 'category',
          data: [],
          nameLocation: 'middle',
          name: '期号',
          nameTextStyle: {
            fontSize: 24,
            padding: 12,
            height: 4
          },
          axisLabel: {
            interval: 0,
            margin: 8
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          nameRotate: 0,
          nameLocation: 'middle',
          name: '{x|特\n码\n号\n码}',
          nameTextStyle: {
            rich: {
              x: {
                fontSize: 24,
                padding: 12,
                color: 'black',
                height: 4
              }
            }
          }
        },
        series: [
          {
            name: '特码',
            type: 'line',
            symbolSize: 8,
            symbol: 'circle',
            smooth: true,
            data: []
          }
        ]
      }
    }
  },
  mounted() {
    this.getTrand(this.$route.params.lottery_code, { count: 30 })
    window.addEventListener('resize', this.echartResize, false)
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', this.echartResize, false)
    })
  },
  methods: {
    async getTrand(code, query) {
      this.isLoading = true
      const [data, error] = await getTrand(code, query)
      this.isLoading = false
      if (error) {
        console.error(error)
        return
      }
      this.data = data
      this.line.xAxis.data = data.map(el => el.period.length === 10 ? el.period.substr(el.period.length - 4, 4) : el.period.substr(el.period.length - 3, 3))
      data.forEach(per => {
        per.balls.forEach((ball, ballIndex) => {
          if (ballIndex === 6) {
            this.line.series[0].data.push(this.padZero(ball))
          }
        })
      })
    },
    echartResize() {
      this.$refs.polar.resize()
    },
    padZero(num) {
      return String(num).padStart(2, '0')
    }
  }
}
</script>

<style lang='scss' scoped>
.echarts {
  width: 100%;
  height: 80%;
}
.TeMaZouShi {
  background-color: white;
  width: 1200px;
  height: 500px;
}
</style>

